import { render, staticRenderFns } from "./warehouse_tpl.vue?vue&type=template&id=32fbc313&"
import script from "./warehouse_tpl.vue?vue&type=script&lang=js&"
export * from "./warehouse_tpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports